import { Auth } from "aws-amplify";
import { signInWithPassword } from "@/utils/auth-sign-in";

let signingUp = false;

export async function createAccountAndSignIn(input: {
  email: string; password: string; first_name: string; last_name: string; phone: string;
}) {
  if (signingUp) {
    throw Object.assign(new Error("Registration is already in progress. Please wait."), { code: "SIGN_UP_IN_PROGRESS" });
  }
  signingUp = true;
  let accountCreated = false;
  try {
    await Auth.signUp({
      username: input.email,
      password: input.password,
      attributes: {
        email: input.email,
        given_name: input.first_name,
        family_name: input.last_name,
        phone_number: `+44${input.phone.replace(/^0+/, "").replace(/ /g, "")}`,
      },
    });
    accountCreated = true;
    return await signInWithPassword({ username: input.email, password: input.password });
  } catch (error) {
    if (accountCreated) {
      throw Object.assign(new Error("Your account was created, but we could not sign you in automatically. Please use the sign-in link below."), {
        code: "ACCOUNT_CREATED_SIGN_IN_FAILED", originalError: error,
      });
    }
    throw error;
  } finally {
    signingUp = false;
  }
}
